import type { SessionUser } from "@nimbus-erp/shared";
import { create } from "zustand";

interface State {
  user: SessionUser | null;
  initialized: boolean;
  setSession: (user: SessionUser | null) => void;
  setInitialized: (value: boolean) => void;
}

export const useAdminAuth = create<State>((set) => ({
  user: null,
  initialized: false,
  setSession: (user) => set({ user, initialized: true }),
  setInitialized: (initialized) => set({ initialized }),
}));
